import {
    h,
    computed,
} from 'vue'

import {
    useACheckbox
} from './ACheckbox'

import './acheckbox.scss'

const ACheckbox = {
    name: 'ACheckbox',
    props: {
        modelValue: {
            required: false,
            default: ''
        },
        trueValue: {
            default: true
        },
        falseValue: {
            default: false
        },
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        label: [String, Boolean],
        state: {
            type: Object,
            default: () => ({
                error: false,
                errorMsg: null
            })
        },
    },
    inheritAttrs: false,
    setup: (props, ctx) => {

        const {
            store,
            change,
        } = useACheckbox(props, ctx)

        const renderCheckbox = () => h('div', {
                class: ['a-checkbox', props.error?'error':'',store.state, ctx.attrs.class],
                role: 'checkbox',
                'aria-label': props.label,
                'aria-checked': store.state.checked,
            },
            [
                h('label', {
                    class: ['a-checkbox-wrap']
                }, [
                    h('span', {
                        class: ['a-checkbox-area']
                    }, [
                        h('input', {
                            type: 'checkbox',
                            value: ctx.attrs.value,
                            onChange: $e => change($e),
                            checked: store.state.checked,
                            disabled: props.disabled,
                        }),
                        h('span', {
                            class: ['a-checkbox-control']
                        }, [
                            h('svg', {
                                    class: ['a-checkbox-control-inner'],
                                    viewBox: '0 0 24 30',
                                },
                                [
                                    h('path', {
                                        fill: 'none',
                                        d: 'M 1.73,14.91 8.1,21.28 22.79,6.59'
                                    })
                                ])
                        ])
                    ]),

                    h('span', {
                        class: ['a-checkbox-label'],
                        innerHTML: props.label,
                    })
                ])
            ]
        )

        return {
            renderCheckbox,
            store,
            change
        }
    },
    render() {
        return this.renderCheckbox()
    },
}

export {
    ACheckbox
}